module.exports = __webpack_public_path__ + "img/center_bc@2x.c1d829ac.png";